import type { CSSProperties } from "react";

export type SpinnerSize = "sm" | "md" | "page";

/** 앱(STPM/Taap)과 동일한 사이즈 토큰, 단위 px */
const SPINNER_DIAMETER: Record<SpinnerSize, number> = {
  sm: 16,
  md: 24,
  page: 32,
};

type Props = {
  size?: SpinnerSize;
  color?: string;
};

/**
 * 앱(STPM/Taap)의 스피너와 기하·타이밍이 같은 공용 스피너
 * 사양 출처: AOSP progress_medium_material (Apache-2.0)
 */
const Spinner = ({ size = "md", color }: Props) => {
  const style = {
    "--spinner-size": `${SPINNER_DIAMETER[size]}px`,
    ...(color !== undefined && { "--spinner-color": color }),
  } as CSSProperties;

  return (
    <span className="spinner" role="progressbar" aria-busy="true" style={style}>
      <svg className="spinner__svg" viewBox="0 0 48 48" aria-hidden="true">
        <path className="spinner__arc" pathLength={113.097} d="M24,6 a18,18 0 1,1 0,36 a18,18 0 1,1 0,-36" />
      </svg>
    </span>
  );
};

export default Spinner;
